import { useEffect, useState } from 'react'
import type { ClientOngoingLoad } from '@numeo/types-core'
import { ongoingLoadsApi } from '@/pages/dashboard/pages/updater-agent/pages/ongoing-loads/api/ongoing-loads.api'

/** The board's load record, and whether its first read is still running (the drawer then holds the route box's space). */
interface OngoingLoadRead {
    load: ClientOngoingLoad | undefined
    loading: boolean
}

/**
 * The board's load record for the drawer's route, POD files and check fields. Read again when `version` changes (after a write),
 * keeping the last record meanwhile. A failed read leaves it undefined: the drawer shows what the invoicing row carries.
 */
export const useOngoingLoad = (loadId: string | undefined, version: number): OngoingLoadRead => {
    const [load, setLoad] = useState<ClientOngoingLoad | undefined>(undefined)
    // The id whose first read has finished: until it matches, the record is still being read.
    const [readId, setReadId] = useState<string | undefined>(undefined)
    useEffect(() => {
        if (!loadId) return
        let live = true
        ongoingLoadsApi
            .getOngoingLoadById(loadId)
            .then((read) => {
                if (live) setLoad(read)
            })
            .catch(() => {
                if (live) setLoad(undefined)
            })
            .finally(() => {
                if (live) setReadId(loadId)
            })
        return () => {
            live = false
        }
    }, [loadId, version])
    return { load, loading: !!loadId && readId !== loadId }
}
